if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        
        // 初始化元素引用
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          next_btn_thumbnails: this.querySelector('[id^="GalleryNext"]'),
          Slider_Thumbnails: this.querySelector('[id^="Slider-Thumbnails"]')
        };
        
        // 如果没有缩略图区域，直接返回
        if (!this.elements.thumbnails) return;
        
        // 获取缩略图列表
        this.thumbnailsList = this.elements.thumbnails.querySelectorAll('[data-target]');
        if (this.thumbnailsList.length === 0) return;
        
        // 初始化配置
        this.initConfig();
        
        // 初始化事件监听
        this.initEventListeners();
        
        // 初始化媒体画廊
        this.initGallery();
      }
      
      /**
       * 初始化配置
       */
      initConfig() {
        const firstThumbnailItem = this.elements.Slider_Thumbnails?.querySelector('.thumbnail-list__item');
        
        this.config = {
          currentIndex: 0,
          thumbnailGap: 20,
          thumbnailHeight: firstThumbnailItem ? firstThumbnailItem.offsetHeight : 100, // 默认值
          itemsPerView: 4,
          totalItems: this.thumbnailsList.length
        };
        
        // 计算每个项目的总高度（包括间距）
        this.config.itemTotalHeight = this.config.thumbnailHeight + this.config.thumbnailGap;

      }
      
      /**
       * 初始化事件监听器
       */
      initEventListeners() {
        // 主查看器滑动事件
        this.elements.viewer.addEventListener(
          'slideChanged', 
          debounce(this.onSlideChanged.bind(this), 500)
        );
        
        // 下一张按钮事件
        if (this.elements.next_btn_thumbnails) {
          this.elements.next_btn_thumbnails.addEventListener(
            'click', 
            this.handleNextButton.bind(this)
          );
        }
        
        // 为每个缩略图添加点击事件
        this.thumbnailsList.forEach((mediaToSwitch, index) => {
          const button = mediaToSwitch.querySelector('button');
          if (button) {
            button.addEventListener(
              'click', 
              () => this.setActiveMedia(mediaToSwitch.dataset.target, false, index)
            );
          }
        });
        
        // 桌面布局处理
        this.mql = window.matchMedia('(min-width: 750px)');
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }
      
      /**
       * 初始化画廊
       */
      initGallery() {
        // 激活第一个缩略图
        const firstThumbnail = this.thumbnailsList[0];
        if (firstThumbnail) {
          this.setActiveMedia(firstThumbnail.dataset.target, false, 0);
        }
      }
      
      /**
       * 滑动改变事件处理
       */
      onSlideChanged(event) {
        const currentMediaId = event.detail?.currentElement?.dataset?.mediaId;
        if (!currentMediaId) return;
        
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentMediaId}"]`
        );
        
        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
          
          // 更新当前索引
          const index = Array.from(this.thumbnailsList).indexOf(thumbnail);
          if (index !== -1) {
            this.config.currentIndex = index;
          }
        }
      }
      
      /**
       * 设置活动媒体
       */
      setActiveMedia(mediaId, prepend = false, index = 0) {
        // 更新当前索引
        this.config.currentIndex = index;
        
        // 查找活动媒体元素
        const activeMedia = 
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        
        if (!activeMedia) {
          console.warn(`未找到媒体ID: ${mediaId}`);
          return;
        }
        
        // 移除所有媒体的激活状态
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(element => {
          element.classList.remove('is-active');
        });
        
        // 激活当前媒体
        activeMedia.classList.add('is-active');
        
        // 如果需要前置
        if (prepend) {
          this.prependActiveMedia(activeMedia, mediaId);
        }
        
        // 处理粘性头部
        this.preventStickyHeader();
        
        // 滚动到活动媒体
        this.scrollToActiveMedia(activeMedia);
        
        // 播放活动媒体
        this.playActiveMedia(activeMedia);
        
        // 设置活动缩略图
        this.setActiveThumbnailByMediaId(mediaId);
        
        // 滚动到当前缩略图
        this.scrollToCurrentThumbnail();
      }
      
      /**
       * 前置活动媒体
       */
      prependActiveMedia(activeMedia, mediaId) {
        // 前置主媒体
        if (activeMedia.parentElement.firstChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
        }
        
        // 前置缩略图
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        
        // 重置页面
        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }
      
      /**
       * 滚动到活动媒体
       */
      scrollToActiveMedia(activeMedia) {
        window.setTimeout(() => {
          // 水平滚动
          console.log("!this.mql?.matches:",!this.mql?.matches);
          console.log("this.elements.thumbnails:",this.elements.thumbnails)
          if (!this.mql?.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ 
              left: activeMedia.offsetLeft 
            });
          }
          
          // 垂直滚动（如果需要）
          const activeMediaRect = activeMedia.getBoundingClientRect();
          console.log("activeMediaRect:",activeMediaRect.top)
          if (activeMediaRect.top < -0.5) {
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ 
              top, 
              behavior: 'smooth' 
            });
            
          }
        }, 100);
      }
      
      /**
       * 通过媒体ID设置活动缩略图
       */
      setActiveThumbnailByMediaId(mediaId) {
        if (!this.elements.thumbnails) return;
        
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          
          // 通告无障碍区域
          const mediaPosition = activeThumbnail.dataset.mediaPosition;
          if (mediaPosition) {
            this.announceLiveRegion(activeThumbnail, mediaPosition);
          }
        }
      }
      
      /**
       * 设置活动缩略图
       */
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        
        // 移除所有缩略图的aria-current属性
        this.elements.thumbnails
          .querySelectorAll('button[aria-current]')
          .forEach(button => button.removeAttribute('aria-current'));
        
        // 设置当前缩略图的aria-current属性
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
        }
        
        // 检查缩略图是否可见，如果不可见则滚动
        if (this.elements.thumbnails.isSlideVisible && 
            !this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ 
            left: thumbnail.offsetLeft 
          });
        }
      }
      
      /**
       * 下一张按钮处理
       */
      handleNextButton() {
        const nextIndex = (this.config.currentIndex + 1) % this.config.totalItems;
        const nextThumbnail = this.thumbnailsList[nextIndex];
        
        if (nextThumbnail) {
          this.setActiveMedia(nextThumbnail.dataset.target, false, nextIndex);
        }
      }
      
      /**
       * 滚动到当前缩略图
       */
    /**
     * 滚动到当前缩略图
     */
          /**
     * 滚动到当前缩略图（基于索引的版本）
     */
      scrollToCurrentThumbnail() {
          if (!this.elements.Slider_Thumbnails) return;
          
          const currentIndex = this.config.currentIndex;
          const itemsPerView = this.config.itemsPerView;
          const itemTotalHeight = this.config.itemTotalHeight;
          
          // 计算滚动位置，使当前缩略图在可视区域顶部
          let scrollTop = 0;
          
          if (currentIndex < itemsPerView - 1) {
              // 前几个项目，不需要滚动
              scrollTop = 0;
          } else {
              // 计算让当前项目出现在可视区域顶部的滚动位置
              scrollTop = (currentIndex - Math.floor(itemsPerView / 2)) * itemTotalHeight;
              
              // 确保不会滚动过头
              const maxScroll = this.elements.Slider_Thumbnails.scrollHeight - 
                              this.elements.Slider_Thumbnails.clientHeight;
              scrollTop = Math.max(0, Math.min(scrollTop, maxScroll));
          }
          
          // 执行滚动
          this.elements.Slider_Thumbnails.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
          });
          
          console.log(`滚动到缩略图 ${currentIndex}: 位置 ${scrollTop}`);
      }
      
      /**
       * 通告无障碍区域
       */
      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;
        
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML = 
            window.accessibilityStrings?.imageAvailable?.replace('[index]', position) || 
            `图片 ${position} 可用`;
          
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };
        
        // 触发图片重新加载
        if (image.src) {
          image.src = image.src;
        }
      }
      
      /**
       * 播放活动媒体
       */
      playActiveMedia(activeItem) {
        if (window.pauseAllMedia) {
          window.pauseAllMedia();
        }
        
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia?.loadContent) {
          deferredMedia.loadContent(false);
        }
      }
      
      /**
       * 防止粘性头部显示
       */
      preventStickyHeader() {
        if (!this.stickyHeader) {
          this.stickyHeader = document.querySelector('sticky-header');
        }
        
        if (this.stickyHeader) {
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
      }
      
      /**
       * 移除列表语义
       */
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        
        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach(slide => {
            slide.setAttribute('role', 'presentation');
          });
        }
      }
      
      /**
       * 组件销毁时的清理
       */
      disconnectedCallback() {
        // 这里可以添加清理代码
        if (this.elements.next_btn_thumbnails) {
          this.elements.next_btn_thumbnails.removeEventListener('click', this.handleNextButton);
        }
      }
    }
  );
}